import { getExtraHours, calcExtraHoursTotal } from "./extraHoursBilling";
import { billingRowTotal } from "./Reportes";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

/* ================== Axios base ================== */
Axios.defaults.baseURL = "https://backend.sansfrontieres-design.com";
Axios.defaults.withCredentials = false;

/* =============== Icon helper (inline SVG, no deps) =============== */
const Icon = ({ name, size = 14, style }) => {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "currentColor", style: { verticalAlign: "-2px", marginRight: 6, ...(style||{}) }, "aria-hidden": true };
  switch (name) {
    case "excel": return (<svg {...common}><rect x="2" y="4" width="16" height="16" rx="3" ry="3" fill="currentColor"/><path d="M7.5 9.5l5 5m0-5l-5 5" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/></svg>);
    case "logout": return (<svg {...common}><path d="M13 4a1 1 0 1 0-2 0v6H7a1 1 0 1 0 0 2h4v6a1 1 0 1 0 2 0V4z"/><path d="M17 7a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1z"/></svg>);
    case "back": return (<svg {...common}><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
    case "star-off": return (<svg {...common}><path d="M12 4.5l2.09 4.23 4.67.68-3.38 3.3.8 4.66L12 15.9l-4.18 2.2.8-4.66-3.38-3.3 4.67-.68L12 4.5z" opacity=".35"/><path d="M3.707 2.293a1 1 0 0 1 1.414 0l15.586 15.586a1 1 0 1 1-1.414 1.414L3.707 3.707a1 1 0 0 1 0-1.414z"/></svg>);
    case "x-circle": return (<svg {...common}><circle cx="12" cy="12" r="10" fill="currentColor" opacity=".3"/><path d="M9 9l6 6m0-6l-6 6" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>);
    default: return null;
  }
};

/* ================== Helpers HTTP ================== */
const postJSON = (url, payload) =>
  Axios.post(url, payload, { headers: { "Content-Type": "application/json" } });

const postWriteJSON = (url, payload) =>
  Axios.post(url, { ...(payload || {}), __no_history: 1 }, { headers: { "Content-Type": "application/json" } });

function getMyWorkId(){
  try{
    const w = JSON.parse(sessionStorage.getItem("loggedWorker") || localStorage.getItem("loggedWorker") || "{}");
    if (w.workid || w.Workid) return String(w.workid || w.Workid).trim();
  }catch(e){}
  return "";
}
Axios.defaults.headers.common["X-Login-User"] = getMyWorkId();

/* ================== Helpers de fecha ================== */
function nowSql() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  const ss = pad(d.getSeconds());
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}
function formatDateTime(value) {
  if (!value) return "";
  const dt = new Date(value);
  if (isNaN(dt)) {
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?$/);
    if (!m) return String(value);
    const [, Y, M, D, h = "00", i = "00", s = "00"] = m;
    const dt2 = new Date(Number(Y), Number(M) - 1, Number(D), Number(h), Number(i), Number(s));
    if (isNaN(dt2)) return String(value);
    return dt2.toLocaleString();
  }
  return dt.toLocaleString();
}

/* ============== Utils export ============== */
function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

const statusOptions = [
  "Not Assigned","Assigned","In Process","In Hold","Correction","Ready for QC",
];
const userOptions = ["Marco","Naara","Pilar","Alessandra","Elizet","Nelson","Ibet"];
const typeOptions = [
  "Asbuilt","Design","Route","Route FTTP","Fiber FTTP","Fiber Design BAU","Fiber Asbuilt BAU","Fiber Correction To Pay",
];
const closeEpOptions = ["Opened EP","Closed EP"];
const projectOptions = [
  "Project-01","Project-02","Project-03","Project-04","Project-05","Project-06","Project-07","Project-08",
];

const normalize = (v) => (v ?? "").toString().toLowerCase().replace(/[\s-]+/g, "");
const toId = (v) => (v === null || v === undefined ? "" : String(v));

const projectPalette = {
  "project01": { bg: "#F7D1B9", fg: "#5D2A0A" },
  "project02": { bg: "#F4C6BC", fg: "#5D1A0A" },
  "project03": { bg: "#EBD6FF", fg: "#4A2A6A" },
  "project04": { bg: "#F2E5FF", fg: "#4A2A6A" },
  "project05": { bg: "#DDF4ED", fg: "#0B4F4A" },
  "project06": { bg: "#E3EEFF", fg: "#104A7A" },
  "project07": { bg: "#EAF5D7", fg: "#3D5E0A" },
  "project08": { bg: "#F5EEC0", fg: "#5D4B00" },
};
const projectStyle = (val) => {
  const k = normalize(val);
  const c = projectPalette[k];
  return c ? { background: c.bg, color: c.fg } : {};
};
const optionClassForProject = (val) => "project-opt-" + normalize(val).replace(/[\s-]+/g, "");

// Read-only amounts shared by both invoice panels and their download.
const invoiceBillingColumns = [
  { key: "jbhrex", label: "Hr Extras", value: r => getExtraHours(r).toFixed(2) },
  { key: "extraClient", label: "Total x H extras (Main / Coax Bentley)", value: r => calcExtraHoursTotal(r, "CLIENT").toFixed(2) },
  { key: "totalClient", label: "TOTAL (Main / Coax Bentley)", value: r => billingRowTotal(r).toFixed(2) },
  { key: "extraSfd", label: "Total x H extras (SFD)", value: r => calcExtraHoursTotal(r, "SFD").toFixed(2) },
  { key: "totalSfd", label: "TOTAL (SFD)", value: r => billingRowTotal(r, true).toFixed(2) },
];

/* ========= Sección reutilizable de Grid ========= */
function GridSection({
  sectionKey,              // "A" | "B"
  records,
  setRecords,
  loggedUser,
  onFilteredChange,        // (rows) => void
  onFavoriteIdsChange,     // (ids) => void
  onSelectedIdsChange,     // (ids) => void
  pushToast,
  allowEditing = false,    // 🔒 por defecto bloqueado
  allowSelect = true,
  allowFavorites = true,
  variant = "top",         // "top" | "bottom" -> color de filas
  clearSelectionToken,     // cambia para forzar limpiar selección
}) {

  const [filters, setFilters] = useState({
    jobid:"", status:"", user:"", type:"", closeep:"", project:"",
    notes:"", proname:"", proport:"", ou:"", lob:"", comty:"",
    routeaerial:"", routeug:"", coaxae:"", coaxug:"", asbae:"", asbug:"",
    lode:"", hc:""
  });
  const [selectedRows, setSelectedRows] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`selected:${sectionKey}:${normalize(loggedUser||"")}`)) ?? []; } catch { return []; }
  });
  const [favoriteRows, setFavoriteRows] = useState(() => {
    try { return JSON.parse(localStorage.getItem(`favorites:${sectionKey}:${normalize(loggedUser||"")}`)) ?? []; } catch { return []; }
  });
  const [editingCell, setEditingCell] = useState(null); // {id, field}
  const [editValue, setEditValue] = useState("");

  useEffect(() => { if (!loggedUser && (sessionStorage.getItem("invoiceAccess") || localStorage.getItem("invoiceAccess")) !== "1") return;
    localStorage.setItem(`favorites:${sectionKey}:${normalize(loggedUser)}`, JSON.stringify(favoriteRows));
    onFavoriteIdsChange?.(favoriteRows);
  }, [favoriteRows, loggedUser, sectionKey, onFavoriteIdsChange]);

  useEffect(() => {
    if (!loggedUser && (sessionStorage.getItem("invoiceAccess") || localStorage.getItem("invoiceAccess")) !== "1") return;
    localStorage.setItem(`selected:${sectionKey}:${normalize(loggedUser)}`, JSON.stringify(selectedRows));
    onSelectedIdsChange?.(selectedRows);
  }, [selectedRows, loggedUser, sectionKey, onSelectedIdsChange]);

  // Limpia selección cuando cambia la señal del padre
  useEffect(() => {
    setSelectedRows([]);
  }, [clearSelectionToken]);

  const filteredRecords = useMemo(() => {
    const matchText = (value, needle) => !needle || normalize(value).includes(normalize(needle));
    const matchEq = (value, needle) => !needle || normalize(value) === normalize(needle);
    return (records || []).filter((r) => {
      const f = filters;
      if (!matchText(r?.jobid, f.jobid)) return false;
      if (!matchEq(r?.jobsta, f.status)) return false;
      if (!matchEq(r?.jobuser, f.user)) return false;
      if (!matchEq(r?.jobti, f.type)) return false;
      if (!matchEq(r?.jobclo, f.closeep)) return false;
      if (!matchEq(r?.jobpro, f.project)) return false;
      if (!matchText(r?.jobnotes, f.notes)) return false;
      if (!matchText(r?.jobproname, f.proname)) return false;
      if (!matchText(r?.jobproport, f.proport)) return false;
      if (!matchText(r?.jobou, f.ou)) return false;
      if (!matchText(r?.joblob, f.lob)) return false;
      if (!matchText(r?.jobcomty, f.comty)) return false;
      if (!matchText(r?.jobrouteaerial, f.routeaerial)) return false;
      if (!matchText(r?.jobrouteug, f.routeug)) return false;
      if (!matchText(r?.jobcoaxae, f.coaxae)) return false;
      if (!matchText(r?.jobcoaxug, f.coaxug)) return false;
      if (!matchText(r?.jobasbae, f.asbae)) return false;
      if (!matchText(r?.jobasbug, f.asbug)) return false;
      if (!matchText(r?.joblode, f.lode)) return false;
      if (!matchText(r?.jobhc, f.hc)) return false;
      return true;
    });
  }, [records, filters]);
  // --- Sorting for five columns (Status, User, Type, EP Status, Project) ---
  const [sortKey, setSortKey] = useState(null); // 'jobsta' | 'jobuser' | 'jobti' | 'jobclo' | 'jobpro'
  const [sortDir, setSortDir] = useState('asc');
  const onSort = (key) => {
    setSortKey((prev) => {
      if (prev === key) {
        setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'));
        return prev;
      } else {
        setSortDir('asc');
        return key;
      }
    });
  };
  const sortedRecords = useMemo(() => {
    if (!sortKey) return filteredRecords;
    const arr = [...filteredRecords];
    arr.sort((a, b) => {
      const va = (a?.[sortKey] ?? '').toString().toLowerCase();
      const vb = (b?.[sortKey] ?? '').toString().toLowerCase();
      if (va < vb) return sortDir === 'asc' ? -1 : 1;
      if (va > vb) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return arr;
  }, [filteredRecords, sortKey, sortDir]);


  useEffect(() => { onFilteredChange?.(filteredRecords); }, [filteredRecords, onFilteredChange]);

  const visibleIds = useMemo(() => filteredRecords.map((r) => toId(r.jobid)), [filteredRecords]);
  const allSelected = allowSelect && visibleIds.length > 0 && visibleIds.every((id) => selectedRows.includes(id));
  const toggleSelectAll = (checked) => {
    if (!allowSelect) return;
    setSelectedRows((prev) => checked ? Array.from(new Set([...prev, ...visibleIds])) : prev.filter((id) => !new Set(visibleIds).has(id)));
  };

  const onFilterChange = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));

  // 🔒 Bloquear edición: solo será editable si allowEditing === true
  const editableFields = new Set([
    "jobid","jobsta","jobuser","jobti","jobclo","jobpro","jobnotes","jobproname","jobproport","jobou","joblob",
    "jobcomty","jobrouteaerial","jobrouteug","jobcoaxae","jobcoaxug","jobasbae","jobasbug","joblode","jobhc",
  ]);

  const isTempId = (val) => {
    if (!val) return false;
    const s = String(val).trim().toLowerCase();
    return /^jobid\s*nuevo-\d+$/.test(s);
  };

  const startEdit = (id, field, currentVal) => {
    if (!allowEditing) return;                 // ⛔ bloqueado
    if (!editableFields.has(field)) return;
    let initial = currentVal ?? "";
    if (field === "jobid" && isTempId(currentVal)) initial = "";
    setEditingCell({ id: toId(id), field });
    setEditValue(initial);
  };
  const cancelEdit = () => { setEditingCell(null); setEditValue(""); };

  const persistFieldChange = async (jobid, field, value) => {
    const jid = String(jobid ?? "").trim();
    if (field === "jobsta") {
      const payload = { jobid: jid, [field]: value, __no_history: 0 };
      const res = await postJSON("/update_project.php", payload);
      if (!res?.data || res.data.status !== "success") throw new Error(res?.data?.message || "Respuesta no exitosa");
      return true;
    } else {
      const payload = { jobid: jid, [field]: value };
      const res = await postWriteJSON("/update_project.php", payload);
      if (!res?.data || res.data.status !== "success") throw new Error(res?.data?.message || "Respuesta no exitosa");
      return true;
    }
  };
  const persistJobIdChange = async (oldId, newId) => {
    const res = await postWriteJSON("/update_jobid.php", {
      old_jobid: String(oldId ?? "").trim(),
      new_jobid: String(newId ?? "").trim(),
    });
    if (!res?.data || res.data.status !== "success") throw new Error(res?.data?.message || "No se pudo actualizar el Job Id");
    return true;
  };

  const commitEdit = async (valueOverride) => {
    if (!allowEditing) return;                 // ⛔ bloqueado
    if (!editingCell) return;
    const { id, field } = editingCell;
    const newVal = valueOverride !== undefined ? valueOverride : editValue;

    const currentRecord = records.find((r) => toId(r.jobid) === id) || {};
    const current = currentRecord?.[field] ?? "";
    if (String(current) === String(newVal)) { cancelEdit(); return; }

    const prev = records;
    let next = records.map((r) => (toId(r.jobid) === id ? { ...r, [field]: newVal } : r));
    setRecords(next);

    const wasTemp = isTempId(id);
    const newId = field === "jobid" ? String(newVal).trim() : id;
    const newIsTemp = isTempId(newId);

    try {
      if (wasTemp) {
        if (field === "jobid") {
          if (!newIsTemp && newId) {
            const recordAfterEdit =
              next.find((r) => toId(r.jobid) === newId) ||
              next.find((r) => toId(r.jobid) === id);
            const res = await postWriteJSON("/create_project.php", recordAfterEdit || {});
            if (!res?.data || res.data.status !== "success") throw new Error(res?.data?.message || "Error al crear");
            const stamped = { ...(res.data || recordAfterEdit), jobdatesub: (res.data?.jobdatesub) || nowSql() };
            next = next.map((r) => (toId(r.jobid) === newId ? { ...r, ...stamped } : r));
            setRecords(next);
            pushToast?.("Registro creado.", "success");
          } else {
            pushToast?.("Cambio aplicado (temporal).", "success");
          }
        } else {
          pushToast?.("Cambio aplicado (temporal).", "success");
        }
      } else {
        if (field === "jobid") {
          await persistJobIdChange(id, newId);
          setRecords((curr) => curr.map((r) => (toId(r.jobid) === newId ? { ...r, jobdatesub: nowSql() } : r)));
          pushToast?.("Job ID actualizado.", "success");
        } else {
          await persistFieldChange(id, field, newVal);
          setRecords((curr) => curr.map((r) => (toId(r.jobid) === id ? { ...r, jobdatesub: nowSql() } : r)));
          pushToast?.("Cambios guardados.", "success");
        }
      }
    } catch (err) {
      alert(`No se pudo guardar el cambio en el servidor.\n\n${err?.message || "Error desconocido"}`);
      setRecords(prev);
      pushToast?.("No se pudo guardar.", "error");
    } finally {
      cancelEdit();
    }
  };

  const handleCheckboxChange = (e, jobId) => {
    if (!allowSelect) return;
    const id = toId(jobId);
    setSelectedRows((prev) => e.target.checked ? Array.from(new Set([...prev, id])) : prev.filter((x) => x !== id));
  };
  const toggleFavorite = (jobId) => {
    if (!allowFavorites) return;
    const id = toId(jobId);
    setFavoriteRows((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };

  function statusPillClass() { return "pill pill-status-green"; }

  return (
    <div className={`card shadow-sm p-3 grid-card ${variant === "top" ? "grid-top" : "grid-bottom"}`}>
      <div className="grid-scroll">
        <table className="table table-bordered table-hover grid-table">
          <colgroup>
            <col style={{ width: "50px" }} />
            <col style={{ width: "50px" }} />
            <col style={{ width: "170px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "150px" }} />
            <col style={{ width: "170px" }} />
            <col style={{ width: "140px" }} />
            <col style={{ width: "220px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "240px" }} />
            <col style={{ width: "180px" }} />
            <col style={{ width: "150px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "160px" }} />
            <col style={{ width: "140px" }} />
            <col style={{ width: "140px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "120px" }} />
            <col style={{ width: "100px" }} />
            {invoiceBillingColumns.map(c => <col key={c.key} style={{ width: c.key === "jbhrex" ? "110px" : "230px" }} />)}
          </colgroup>

          <thead>
            <tr>
              <th>
                {allowSelect ? (
                  <input type="checkbox" checked={allSelected} onChange={(e) => toggleSelectAll(e.target.checked)} title="Seleccionar visibles" />
                ) : <span>#</span>}
              </th>
              <th>
                {allowFavorites ? <span title="Favoritos" style={{ fontSize: "18px" }}>☆</span> : <span>&nbsp;</span>}
              </th>

              {/* Job Id */}
              <th className="filter-input" data-label="Job Id">
                <input className="form-control form-control-sm header-input" placeholder="Job Id" value={filters.jobid} onChange={(e) => onFilterChange("jobid", e.target.value)} />
              </th>

              <th className="filter-cell show-placeholder sortable" data-label="Status" onClick={() => onSort("jobsta")}>
                <select className="form-select form-select-sm" value={filters.status} onChange={(e) => onFilterChange("status", e.target.value)} onClick={(e) => e.stopPropagation()}>
                  <option value="">All</option>
                  {statusOptions.map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
              <span className="sort-arrow">{sortKey === "jobsta" ? (sortDir === "asc" ? "▲" : "▼") : ""}</span></th>

              <th className="filter-cell show-placeholder sortable" data-label="User" onClick={() => onSort("jobuser")}>
                <select className="form-select form-select-sm" value={filters.user} onChange={(e) => onFilterChange("user", e.target.value)} onClick={(e) => e.stopPropagation()}>
                  <option value="">All</option>
                  {userOptions.map((u) => <option key={u} value={u}>{u}</option>)}
                </select>
              <span className="sort-arrow">{sortKey === "jobuser" ? (sortDir === "asc" ? "▲" : "▼") : ""}</span></th>

              <th className="filter-cell show-placeholder sortable" data-label="Type" onClick={() => onSort("jobti")}>
                <select className="form-select form-select-sm" value={filters.type} onChange={(e) => onFilterChange("type", e.target.value)} onClick={(e) => e.stopPropagation()}>
                  <option value="">All</option>
                  {typeOptions.map((t) => <option key={t} value={t}>{t}</option>)}
                </select>
              <span className="sort-arrow">{sortKey === "jobti" ? (sortDir === "asc" ? "▲" : "▼") : ""}</span></th>

              <th className="filter-cell show-placeholder sortable" data-label="EP Status" onClick={() => onSort("jobclo")}>
                <select className="form-select form-select-sm" value={filters.closeep} onChange={(e) => onFilterChange("closeep", e.target.value)} onClick={(e) => e.stopPropagation()}>
                  <option value="">All</option>
                  {closeEpOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
              <span className="sort-arrow">{sortKey === "jobclo" ? (sortDir === "asc" ? "▲" : "▼") : ""}</span></th>

              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Submission Date</th>

              <th className="filter-cell show-placeholder sortable" data-label="Project" onClick={() => onSort("jobpro")}>
                <select className="form-select form-select-sm" value={filters.project} onChange={(e) => onFilterChange("project", e.target.value)} onClick={(e) => e.stopPropagation()}>
                  <option value="">All</option>
                  {projectOptions.map((p) => <option key={p} value={p} className={optionClassForProject(p)}>{p}</option>)}
                </select>
              <span className="sort-arrow">{sortKey === "jobpro" ? (sortDir === "asc" ? "▲" : "▼") : ""}</span></th>{/* resto headers */}
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>OU-Comcast</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Route Aerial</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Route UG</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Coax AE</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Coax UG</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Asb AE</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Asb UG</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>LODE</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>HC</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Project Name</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>Project Port</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>COM-Job type</th>
              <th style={{ fontWeight: 700, color: "var(--th-color)" }}>LOB</th>
            

              {/* Notes */}
              <th className="filter-input" data-label="Notes">
                <input className="form-control form-control-sm header-input" placeholder="Notes" value={filters.notes} onChange={(e) => onFilterChange("notes", e.target.value)} />
              </th>

              {invoiceBillingColumns.map(c => <th key={c.key} title="Importe calculado, no editable">{c.label}</th>)}
              </tr>
          </thead>

          {/* Body */}
          <tbody style={{ whiteSpace: "nowrap" }}>
            {sortedRecords.map((r, idx) => {
              const id = toId(r.jobid);
              const isFav = favoriteRows.includes(id);
              const isSel = selectedRows.includes(id);
              const rowNumber = idx + 1;

              const Cell = ({ field, value, pill, selectOptions, area, editor }) => {
                const isEditing = editingCell && editingCell.id === id && editingCell.field === field;
                const editable = allowEditing && editableFields.has(field); // 🔒 respeta allowEditing
                const start = () => editable && startEdit(id, field, value);
                const onKey = (e) => { if (e.key === "Enter") commitEdit(); if (e.key === "Escape") cancelEdit(); };

                const clickStartIfEmpty = () => {
                  if (!editable) return;
                  const empty = value === "" || value === null || value === undefined;
                  if (empty) startEdit(id, field, value);
                };

                const areaRef = useRef(null);
                const inputRef = useRef(null);
                const [localValue, setLocalValue] = useState(editValue);

                useEffect(() => {
                  if (isEditing && ["notes","proname","proport","ou","lob"].includes(area)) {
                    setLocalValue(value ?? "");
                  }
                }, [isEditing, value, area]);

                useEffect(() => {
                  if (!isEditing) return;
                  if (["notes","proname","proport","ou","lob"].includes(area)) {
                    if (areaRef.current) {
                      const el = areaRef.current;
                      requestAnimationFrame(() => {
                        try { const L = el.value.length; el.setSelectionRange(L, L); el.focus(); } catch {}
                      });
                    }
                  } else if (inputRef.current) {
                    try { const L = inputRef.current.value.length; inputRef.current.setSelectionRange(L, L); inputRef.current.focus(); } catch {}
                  }
                }, [isEditing, area]);

                // No se mostrarán inputs/selects si editable=false (locked)
                if (isEditing && editable && selectOptions) {
                  return (
                    <select
                      autoFocus
                      className="form-select form-select-sm"
                      value={editValue ?? ""}
                      onChange={(e) => setEditValue(e.target.value)}
                      onBlur={() => commitEdit()}
                      onKeyDown={onKey}
                    >
                      <option value="">— Seleccionar —</option>
                      {selectOptions.map((opt) => (
                        <option key={opt} value={opt} className={pill === "project" ? optionClassForProject(opt) : undefined}>{opt}</option>
                      ))}
                    </select>
                  );
                }

                if (isEditing && editable && ["notes","proname","proport","ou","lob"].includes(area)) {
                  const stop = (e) => e.stopPropagation();
                  const save = () => { commitEdit(localValue); };
                  const escOrSave = (e) => {
                    if (e.key === "Escape") cancelEdit();
                    if ((e.ctrlKey || e.metaKey) && e.key === "Enter") commitEdit(localValue);
                  };
                  const titleMap = {
                    notes: "Editar Notes", proname: "Editar Project Name", proport: "Editar Project Port", ou: "Editar OU", lob: "Editar LOB",
                  };
                  const height = area === "notes" ? "50vh" : "30vh";
                  return (
                    <>
                      <div onClick={cancelEdit} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,.35)", zIndex:9998 }} />
                      <div onClick={stop} style={{ position:"fixed", zIndex:9999, left:"50%", top:"10vh", transform:"translateX(-50%)", width:"min(900px, 90vw)", background:"#fff", borderRadius:12, boxShadow:"0 12px 28px rgba(0,0,0,.2)", padding:12 }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <strong>{titleMap[area] || "Editar"}</strong>
                          <button className="btn btn-sm btn-outline-secondary" onClick={cancelEdit}>×</button>
                        </div>
                        <textarea
                          ref={areaRef}
                          autoFocus
                          className="form-control"
                          style={{ height }}
                          value={localValue}
                          onChange={(e) => setLocalValue(e.target.value)}
                          onKeyDown={escOrSave}
                          placeholder="Escribe aquí…  (Ctrl+Enter para guardar)"
                        />
                        <div className="d-flex justify-content-end gap-2 mt-2">
                          <button className="btn btn-secondary btn-sm" onClick={cancelEdit}><Icon name="x-circle" />Cancelar</button>
                          <button className="btn btn-primary btn-sm" onClick={save}>Guardar</button>
                        </div>
                      </div>
                    </>
                  );
                }

                if (isEditing && editable && field === "jobid") {
                  return (
                    <input
                      ref={inputRef}
                      autoFocus
                      className="form-control form-control-sm"
                      defaultValue={editValue}
                      onBlur={(e) => commitEdit(e.target.value)}
                      onKeyDown={(e) => { if (e.key === "Enter") commitEdit(e.currentTarget.value); if (e.key === "Escape") cancelEdit(); }}
                    />
                  );
                }

                if (isEditing && editable) {
                  return (
                    <input
                      ref={inputRef}
                      autoFocus
                      className="form-control form-control-sm"
                      value={editValue}
                      onChange={(e) => setEditValue(e.target.value)}
                      onBlur={() => commitEdit()}
                      onKeyDown={onKey}
                    />
                  );
                }

                const classForPill =
                  pill === "status" ? statusPillClass(value)
                  : pill === "user" ? "pill pill-user"
                  : pill === "type" ? "pill pill-type"
                  : pill === "closeep" ? "pill pill-closeep"
                  : pill === "project" ? "pill pill-project"
                  : null;

                let display = value ?? "";
                if (editor === "date") display = formatDateTime(value);
                const isEmpty = display === "" || display === null || display === undefined;

                if (classForPill) {
                  const extraStyle = pill === "project" ? projectStyle(value) : undefined;
                  return (
                    <div
                      className={allowEditing ? "cell-editable" : undefined}
                      onDoubleClick={allowEditing ? start : undefined}
                      onClick={allowEditing ? clickStartIfEmpty : undefined}
                      title={allowEditing ? "Doble clic para editar" : undefined}
                    >
                      {isEmpty ? <span className="cell-empty">-</span> : <span className={classForPill} style={extraStyle}>{display}</span>}
                    </div>
                  );
                }

                const contentNode = isEmpty
                  ? <span className="cell-empty">-</span>
                  : ((area === "notes" || area === "proname" || area === "lob") ? <span className="notes-clip" title={String(display)}>{display}</span> : display);

                return (
                  <div
                    className={allowEditing ? "cell-editable" : undefined}
                    onDoubleClick={allowEditing ? start : undefined}
                    onClick={allowEditing ? clickStartIfEmpty : undefined}
                    title={allowEditing ? "Doble clic para editar" : undefined}
                  >
                    {contentNode}
                  </div>
                );
              };

              return (
                <tr key={`${sectionKey}:${id}`} className={isSel ? "row-selected" : ""}>
                  <td className="sel-cell">
                    <span className="row-index">{rowNumber}</span>
                    {allowSelect && (
                      <input
                        type="checkbox"
                        className="row-check"
                        checked={isSel}
                        onChange={(e) => handleCheckboxChange(e, id)}
                        title={`Seleccionar fila ${rowNumber}`}
                      />
                    )}
                  </td>

                  <td>
                    {allowFavorites ? (
                      <span
                        className={`fav-star ${isFav ? "on" : "off"}`}
                        onClick={() => toggleFavorite(id)}
                        title={isFav ? "Quitar de favoritos" : "Marcar como favorito"}
                        role="button"
                        aria-label={isFav ? "Quitar de favoritos" : "Marcar como favorito"}
                      >
                        {isFav ? "★" : "☆"}
                      </span>
                    ) : <span>&nbsp;</span>}
                  </td>

                  <td className="left-cell"><Cell field="jobid" value={r.jobid} /></td>
                  <td className="left-cell"><Cell field="jobsta" value={r.jobsta} pill="status" selectOptions={statusOptions} /></td>
                  <td className="left-cell"><Cell field="jobuser" value={r.jobuser} pill="user" selectOptions={userOptions} /></td>
                  <td className="left-cell"><Cell field="jobti" value={r.jobti} pill="type" selectOptions={typeOptions} /></td>
                  <td className="left-cell"><Cell field="jobclo" value={r.jobclo} pill="closeep" selectOptions={closeEpOptions} /></td>
                  <td><Cell field="jobdatesub" value={r.jobdatesub} editor="date" /></td>
                  <td className="left-cell"><Cell field="jobpro" value={r.jobpro} pill="project" selectOptions={projectOptions} /></td><td><Cell field="jobcomty" value={r.jobcomty} /></td>
                  <td><Cell field="jobrouteaerial" value={r.jobrouteaerial} /></td>
                  <td><Cell field="jobrouteug" value={r.jobrouteug} /></td>
                  <td><Cell field="jobcoaxae" value={r.jobcoaxae} /></td>
                  <td><Cell field="jobcoaxug" value={r.jobcoaxug} /></td>
                  <td><Cell field="jobasbae" value={r.jobasbae} /></td>
                  <td><Cell field="jobasbug" value={r.jobasbug} /></td>
                  <td><Cell field="joblode" value={r.joblode} /></td>
                  <td><Cell field="jobhc" value={r.jobhc} /></td>
                  <td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproname" value={r.jobproname} area="proname" /></div></div></td>
                  <td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobproport" value={r.jobproport} area="proport" /></div></div></td>
                  <td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobou" value={r.jobou} area="ou" /></div></div></td>
                  <td className="wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="joblob" value={r.joblob} area="lob" /></div></div></td>
                
                  <td className="left-cell wide-col clip-cell"><div className="clip-flex"><div className="clip-text"><Cell field="jobnotes" value={r.jobnotes} area="notes" /></div></div></td>

                  {invoiceBillingColumns.map(c => <td key={c.key}>{c.value(r)}</td>)}
                  </tr>
              );
            })}
          </tbody>

          <tfoot>
            <tr>
              <td colSpan={28} style={{ textAlign: "left", background: "#f7f8fd" }}>
                <small className="ms-2 text-muted">
                  Las filas con <em>JobID nuevo-#</em> son temporales; al cambiar el Job Id por uno real, se guardan en el servidor.
                </small>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {filteredRecords.length} registros · {allowSelect ? selectedRows.length : 0} seleccionados · {allowFavorites ? favoriteRows.length : 0} favoritos
        </small>
        <div className="d-flex gap-2">
          {allowSelect && (
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setSelectedRows([])} disabled={selectedRows.length === 0}>
              <Icon name="x-circle" />Clear Selected
            </button>
          )}
          {allowFavorites && (
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setFavoriteRows([])} disabled={favoriteRows.length === 0}>
              <Icon name="star-off" />Clear Favorites
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

/* ================== Página Invoicing ================== */
export default function Invoicing() {
  const navigate = useNavigate();

  const [records, setRecords] = useState([]);
  const [loggedUser, setLoggedUser] = useState(() => {
    try {
      const wr = localStorage.getItem("loggedWorker");
      const w = wr ? JSON.parse(wr) : null;
      return w?.workid || localStorage.getItem("loggedUser") || "";
    } catch {
      return localStorage.getItem("loggedUser") || "";
    }
  });

  const [toasts, setToasts] = useState([]);
  const pushToast = (msg, variant = "success") => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, msg, variant }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3000);
  };

  // Export + botones de estado necesitan saber qué hay filtrado y qué está seleccionado en el grid A
  const [filteredA, setFilteredA] = useState([]);
  const [filteredB, setFilteredB] = useState([]);
  const [favA, setFavA] = useState([]);
  const [favB, setFavB] = useState([]);
  const [selectedA, setSelectedA] = useState([]);
  const [clearSelToken, setClearSelToken] = useState(0);

  const fetchRecords = async () => {
    try {
      const { data } = await Axios.get("/get_projects.php?include_extra_hours=1");
      if (data?.status === "success") {
        setRecords(Array.isArray(data.data) ? data.data : []);
      } else {
        alert("Error al cargar proyectos: " + (data?.message || "desconocido"));
      }
    } catch (err) {
      console.error("Error al cargar proyectos:", err);
      alert("Error de conexión con el servidor.");
    }
  };

  useEffect(() => { let userKey = "";
    const wStr = localStorage.getItem("loggedWorker");
    if (wStr) {
      try {
        const w = JSON.parse(wStr);
        if (w && w.workid) {
          setLoggedUser(w.workid);
          userKey = w.workid;
        }
      } catch {}
    }
    if (!userKey) {
      const u = localStorage.getItem("loggedUser") || "";
      setLoggedUser(u);
    }
    
    fetchRecords();
   }, [navigate]);
if (!loggedUser && (sessionStorage.getItem("invoiceAccess") || localStorage.getItem("invoiceAccess")) !== "1") {
    return (
      <div className="container my-5" style={{ maxWidth: "400px" }}>
      </div>
    );
  }

  /* ============== Export XLS (combina Grid A y Grid B) ============== */
  const buildTableHTML = (rows, favoriteIds) => {
    const thStyle =
      "background:#efe7e3;color:#2f2b26;font-weight:700;text-align:center;white-space:nowrap;border:1px solid #ddd;padding:8px 6px;";
    const tdStyle =
      "border:1px solid #ddd;padding:6px 6px;text-align:center;white-space:nowrap;font-size:12px;";
    const tdLeft = tdStyle + "text-align:left;";
    const pillBase =
      "display:inline-block;padding:6px 12px;border-radius:8px;font-size:12px;font-weight:700;border:1px solid rgba(0,0,0,.06);";
    const statusGreen = "background:#E6F4EA;color:#195A2B;";

    const htmlHead = `
<meta charset="utf-8" />
<style>
  table{ border-collapse:collapse; font-family:Arial,Helvetica,sans-serif; }
  thead tr th{ ${thStyle} }
  tbody tr td{ ${tdStyle} }
</style>`.trim();

    const headers = [
      "#","Fav","Job Id","Status","User","Type","EP Status","Submission Date","Project","Notes",
      "Community","Route Aerial","Route UG","Coax AE","Coax UG","Asb AE","Asb UG","LODE","HC","Project Name","Project Port","OU","LOB",
      ...invoiceBillingColumns.map(c => c.label),
    ];

    const thead =
      "<thead><tr>" +
      headers.map((h) => `<th style="${thStyle}">${escapeHtml(h)}</th>`).join("") +
      "</tr></thead>";

    const tbody =
      "<tbody>" +
      rows.map((r, idx) => {
        const id = toId(r.jobid);
        const isFav = favoriteIds?.includes(id);
        const proj = projectStyle(r.jobpro);
        const projStyle = `background:${proj.background || proj.bg || "#f6d9cf"};color:${proj.color || proj.fg || "#5d1a0a"};`;
        return (
          "<tr>" +
          `<td style="${tdStyle}">${idx + 1}</td>` +
          `<td style="${tdStyle}">${isFav ? "★" : ""}</td>` +
          `<td style="${tdLeft}">${escapeHtml(r.jobid || "")}</td>` +
          `<td style="${tdLeft}"><span style="${pillBase}${statusGreen}">${escapeHtml(r.jobsta || "")}</span></td>` +
          `<td style="${tdLeft}">${escapeHtml(r.jobuser || "")}</td>` +
          `<td style="${tdLeft}">${escapeHtml(r.jobti || "")}</td>` +
          `<td style="${tdLeft}">${escapeHtml(r.jobclo || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobdatesub || "")}</td>` +
          `<td style="${tdLeft}"><span style="${pillBase}${projStyle}">${escapeHtml(r.jobpro || "")}</span></td>` +
          `<td style="${tdLeft}">${escapeHtml(r.jobnotes || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobcomty || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobrouteaerial ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobrouteug ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobcoaxae ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobcoaxug ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobasbae ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobasbug ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.joblode ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobhc ?? "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobproname || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobproport || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.jobou || "")}</td>` +
          `<td style="${tdStyle}">${escapeHtml(r.joblob || "")}</td>` +
          invoiceBillingColumns.map(c => `<td style="${tdStyle}">${escapeHtml(c.value(r))}</td>`).join("") +
          "</tr>"
        );
      }).join("") +
      "</tbody>";

    return { htmlHead, table: `<table>${thead}${tbody}</table>` };
  };

  const exportBothGridsToXLS = () => {
    const A = buildTableHTML(filteredA || [], favA || []);
    const B = buildTableHTML(filteredB || [], favB || []);
    const html = `
<!DOCTYPE html>
<html>
<head>${A.htmlHead}</head>
<body>
  <h3>Grid 1 (Arriba)</h3>
  ${A.table}
  <br/><br/>
  <h3>Grid 2 (Abajo)</h3>
  ${B.table}
</body>
</html>`.trim();

    const blob = new Blob([html], { type: "application/vnd.ms-excel;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const ts = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const name = `invoicing_${ts.getFullYear()}${pad(ts.getMonth() + 1)}${pad(ts.getDate())}_${pad(ts.getHours())}${pad(ts.getMinutes())}.xls`;
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
  };

  /* ======= Actualización masiva de Status (solo usa selección del Grid A) ======= */
  const bulkUpdateStatus = async (newStatus) => {
    if (!selectedA?.length) {
      pushToast("No hay filas seleccionadas en el grid superior.", "error");
      return;
    }
    const ids = selectedA.map(String);
    try {
      // Llamadas en paralelo
      const results = await Promise.allSettled(
        ids.map((jobid) => postJSON("/update_project.php", { jobid, jobsta: newStatus, __no_history: 0 }))
      );

      const ok = results.filter(r => r.status === "fulfilled").length;
      const fail = results.length - ok;

      // Actualiza el estado local
      setRecords((curr) => curr.map((r) => ids.includes(String(r.jobid)) ? { ...r, jobsta: newStatus, jobdatesub: nowSql() } : r));

      pushToast(`${ok} registro(s) actualizados a "${newStatus}"${fail ? ` · ${fail} falló/fallaron` : ""}.`, fail ? "error" : "success");

      // Limpia selección del grid A
      setClearSelToken((x) => x + 1);
    } catch (e) {
      pushToast(`Error actualizando a "${newStatus}": ${e?.message || "desconocido"}`, "error");
    }
  };

  return (
    <div className="container-fluid invoicing-root">
      <style>{`
        .invoicing-root{
          padding-left: 0; padding-right: 0;
          height: 100vh;
          display: flex;
          flex-direction: column;
        }

        :root{
          --grid-card-bg: #f4ede8;
          --th-color: #2f2b26;
          --row-selected-bg: #eaf6ee;
          --row-selected-bg-hover: #e2f3e7;
        }

        .grid-card{
          display:flex; flex-direction:column;
          background: var(--grid-card-bg) !important;
          border-radius: 12px; min-height:0;
          position: relative;
          height: 100%;
        }
        .grid-scroll{
          position:relative; width:100%;
          overflow:auto;
          flex: 1 1 auto;
          min-height: 0;
        }

        /* Fondos por variante */
        .grid-top .grid-table tbody tr td{ background:#E9F6FF; }   /* celeste pastel */
        .grid-bottom .grid-table tbody tr td{ background:#E8F5E9; }/* verde pastel */

        table.grid-table{
          width:100%;
          min-width:1800px;
          text-align:center;
          vertical-align:middle;
          table-layout:fixed;
        }
        table.grid-table thead th{

        :root { --wide-col-w: 240px; }
        :where(th[data-label="Project Name"], th[data-label="Project Port"], th[data-label="COM-Job type"], th[data-label="LOB"], th[data-label="Notes"]){
          width: var(--wide-col-w); min-width: var(--wide-col-w);
        }
        td.wide-col{ width: var(--wide-col-w); min-width: var(--wide-col-w); }
        table.grid-table{ table-layout: fixed; }
        
        /* sort arrows (header click) */
        th.sortable{ position: relative; cursor: pointer; padding-right: 22px; }
        .sort-arrow{ position: absolute; right: 8px; top: 6px; font-size: 12px; opacity: .85; pointer-events: none; }
td.clip-cell{ overflow:hidden !important; }
        td.clip-cell .clip-flex{ display:flex; min-width:0; }
        td.clip-cell .clip-text{ flex:1 1 auto; min-width:0; overflow:hidden !important; text-overflow:ellipsis !important; white-space:nowrap !important; }
        td.clip-cell .clip-text *{ white-space:nowrap !important; max-width:100%; }
        
          position: sticky; top: 0;
          z-index: 3;
          background: #efe7e3;
          color: var(--th-color);
          font-weight:700;
          vertical-align: middle;
          white-space: nowrap;
        }

        .pill{
          display:inline-block; padding:6px 12px;
          border-radius: 8px; font-size:13px; line-height:1; font-weight:700;
          border:1px solid rgba(0,0,0,0.06); user-select:none; white-space:nowrap;
        }
        .pill-status-green{ background:#E6F4EA; color:#195A2B; }
        .pill-user{ background:#e6efff; color:#0b3e91; }
        .pill-type{ background:#f4f0d6; color:#6d5c00; }
        .pill-closeep{ background:#efe8c9; color:#5f4b00; }
        .pill-project{ background:#f6d9cf; color:#5d1a0a; }

        .cell-editable{ cursor:pointer; }
        .cell-editable:hover{ background:#fafafa; }
        .grid-table td{ padding: 9px 8px; }
        .grid-table th{ padding: 12px 8px; }

        .filter-cell{ position:relative; }
        .filter-cell select{ width:100%; }
        .filter-cell.show-placeholder:not(:hover):not(:focus-within) select{
          color: transparent; -webkit-text-fill-color: transparent;
        }
        .filter-cell.show-placeholder:not(:hover):not(:focus-within)::after{
          content: attr(data-label);
          position:absolute; left:12px; top:50%; transform: translateY(-50%);
          pointer-events:none; color: var(--th-color); font-weight:700;
        }
        .filter-cell.show-placeholder:hover::after,
        .filter-cell.show-placeholder:focus-within::after{
          content: "";
        }
        .filter-cell select option{ color:#212529; }

        .filter-input { position: relative; }
        .filter-input:has(.header-input:placeholder-shown):not(:hover):not(:focus-within)::after{
          content: attr(data-label);
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          pointer-events: none;
          color: var(--th-color);
          font-weight: 700;
        }
        .filter-input:has(.header-input:placeholder-shown):not(:hover):not(:focus-within) .header-input{
          color: transparent;
          -webkit-text-fill-color: transparent;
          caret-color: transparent;
        }
        .filter-input:hover::after,
        .filter-input:focus-within::after{ content: ""; }

        .left-cell{ text-align:left; }

        /* checkbox/índice */
        td.sel-cell{ position:relative; }
        .row-index{ display:inline-block; min-width: 20px; opacity: 0.9; }
        .row-check{
          position:absolute; left:50%; top:50%; transform: translate(-50%, -50%);
          opacity:0; pointer-events:none; transition: opacity .15s ease;
        }
        td.sel-cell:hover .row-check{ opacity:1; pointer-events:auto; }
        td.sel-cell:hover .row-index{ opacity:0; }

        /* Estrella favorito */
        .fav-star{
          cursor:pointer;
          font-size:20px;
          line-height:1;
          color:#ff9800;
          transition: transform .12s ease, opacity .12s ease;
        }
        .fav-star.off{ opacity:.85; }
        .fav-star:hover{ transform: scale(1.1); }

        .cell-empty{ color:#9aa0a6; font-style: italic; }

        .grid-table tbody tr.row-selected td{
          background: var(--row-selected-bg) !important;
        }
        .grid-table tbody tr.row-selected:hover td{
          background: var(--row-selected-bg-hover) !important;
        }
        .grid-table tbody tr.row-selected td.sel-cell .row-check{
          opacity: 1;
          pointer-events: auto;
        }
        .grid-table tbody tr.row-selected td.sel-cell .row-index{
          opacity: 0;
        }

        .notes-clip{
          display:block;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
        }

        .grid-topbar .btn{ font-size:14px; font-weight:500; padding:6px 12px; border-width:1px; }
        .btn-pastel-green{ background:#E8F5E9; border-color:#C8E6C9; color:#2E7D32; }
        .btn-pastel-green:hover{ filter:brightness(.96); }
        .btn-pastel-purple{ background:#EDE7F6; border-color:#D1C4E9; color:#5E35B1; }
        .btn-pastel-purple:hover{ filter:brightness(.96); }
        .btn-solid-danger{ background:#E53935; border-color:#E53935; color:#fff; }
        .btn-solid-danger:hover{ filter:brightness(.95); }

        .panes{
          flex: 1 1 auto;
          min-height: 0;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .panes > .grid-card{
          flex: 1 1 0;
        }
      `}</style>

      {/* Topbar con 5 botones */}
      <div className="card shadow-sm p-3 mb-3">
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0" style={{ color: "#2f2b26", fontWeight: 700 }}>
            Invoicing - Usuario: {loggedUser}
          </h5>
          <div className="d-flex gap-2 grid-topbar">
            <button className="btn btn-sm btn-pastel-green" onClick={exportBothGridsToXLS} title="Exportar ambos grids a Excel">
              <Icon name="excel" size={16} /> Exportar XLS
            </button>
            <button className="btn btn-sm btn-pastel-purple" onClick={() => navigate("/grid")} title="Regresar a GridPage">
              <Icon name="back" size={16} /> Regresar
            </button>


            {/* NUEVOS: Invoiced/Billed sobre selección del grid de arriba */}
            <button className="btn btn-sm btn-pastel-purple" onClick={() => bulkUpdateStatus("Invoicing")} title="Marcar seleccionados (arriba) como Invoiced">
              Invoicing
            </button>
            <button className="btn btn-sm btn-pastel-green" onClick={() => bulkUpdateStatus("Billed")} title="Marcar seleccionados (arriba) como Billed">
              Billed
            </button>

  <button
              className="btn btn-sm btn-solid-danger"
              onClick={() => {
                localStorage.removeItem("loggedUser");
                localStorage.removeItem("loggedWorker");
                sessionStorage.removeItem("invoiceAccess");
                localStorage.removeItem("invoiceAccess");
                sessionStorage.removeItem("loggedWorker");
                delete Axios.defaults.headers.common["X-Login-User"];
                delete Axios.defaults.headers.common["x-login-user"];
              }}
            >
              <Icon name="logout" size={16} /> Cerrar Sesión
            </button>



          </div>
        </div>
      </div>

          
      {/* DOS PANELES (mitad y mitad) */}
      <div className="panes">
        {/* Grid 1 (arriba) - editable: NO, selección: SÍ, favoritos: SÍ */}
        <GridSection
          sectionKey="A"
          records={records}
          setRecords={setRecords}
          loggedUser={loggedUser}
          onFilteredChange={setFilteredA}
          onFavoriteIdsChange={setFavA}
          onSelectedIdsChange={setSelectedA}
          pushToast={pushToast}
          allowEditing={false}
          allowSelect={true}
          allowFavorites={true}
          variant="top"
          clearSelectionToken={clearSelToken}
        />

        {/* Grid 2 (abajo) - bloqueado total (sin selección ni favoritos) */}
        <GridSection
          sectionKey="B"
          records={records}
          setRecords={setRecords}
          loggedUser={loggedUser}
          onFilteredChange={setFilteredB}
          onFavoriteIdsChange={setFavB}
          pushToast={pushToast}
          allowEditing={false}
          allowSelect={false}
          allowFavorites={false}
          variant="bottom"
        />
      </div>

      {/* Toasts */}
      <div style={{position:"fixed", right:16, bottom:16, zIndex:9999}}>
        {toasts.map(t => (
          <div
            key={t.id}
            className="shadow-sm mb-2 px-3 py-2 rounded text-white"
            style={{background: t.variant==="success" ? "#2e7d32" : t.variant==="error" ? "#c62828" : "#6c757d"}}
          >
            {t.msg}
          </div>
        ))}
      </div>
    </div>
  );
}
